import { BrowserRouter, Route, Routes } from "react-router-dom";
import {
  AdminDashboardLayout,
  AdminDashboard,
  FreeRegistrationList,
  DemoGivenList,
  FreeTrialList,
  FreeTrialExpiredList,
  PaidSubscriptionList,
  PaidSubscriptionExpiredList,
  AllIssues,
  Bugs,
  ChangeRequests,
  FeatureRequest,
  Feedback,
} from "../admin";
import UserManagementList from "../admin/pages/Role_Management/list";
import InvoiceManagement from "../admin/pages/Invoice_Management/InvoiceManagement";
import DemoRequestsList from "../admin/pages/demo_requests/list";
import GeneralEnquiryList from "../admin/pages/general_enquiry/list";

function AdminRoute() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <>
            <Route path="/" element={<AdminDashboardLayout />}>
              <Route path="/" element={<AdminDashboard />} />
              <Route
                path="/free-registration-list"
                element={<FreeRegistrationList />}
              />
              <Route path="/demo-given-list" element={<DemoGivenList />} />
              <Route path="/free-trial-list" element={<FreeTrialList />} />
              <Route
                path="/free-trial-expired-list"
                element={<FreeTrialExpiredList />}
              />
              <Route
                path="/paid-subscription-list"
                element={<PaidSubscriptionList />}
              />
              <Route
                path="/paid-subscription-expired-list"
                element={<PaidSubscriptionExpiredList />}
              />
              <Route path="/role-management" element={<UserManagementList />} />
              <Route path="/all-issues" element={<AllIssues />} />
              <Route path="/bugs" element={<Bugs />} />
              <Route path="/change-requests" element={<ChangeRequests />} />
              <Route path="/feature-requests" element={<FeatureRequest />} />
              <Route path="/feedback" element={<Feedback />} />

              <Route path="/invoice-management" element={<InvoiceManagement />} />
              <Route path="/demo-requests" element={<DemoRequestsList />} />
              <Route path="/general-enquiry" element={<GeneralEnquiryList />} />
            </Route>
          </>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default AdminRoute;
